<button class="btn {{ btnClass }}" [type]="type" [disabled]="loading" [ngClass]="{ loading: loading }">
	<div class="btn-spinner float-left" *ngIf="loading"></div>
	<span *ngIf="!loading">
		<ng-content></ng-content>
	</span>
	<span *ngIf="loading"><i class="fas fa-spin fa-spinner mr-2"></i>{{ loadingText }}</span>
</button>
